import { render, staticRenderFns } from "./f-model.vue?vue&type=template&id=59382bc5&lang=pug&"
import script from "./f-model.vue?vue&type=script&lang=js&"
export * from "./f-model.vue?vue&type=script&lang=js&"
import style0 from "./f-model.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59382bc5')) {
      api.createRecord('59382bc5', component.options)
    } else {
      api.reload('59382bc5', component.options)
    }
    module.hot.accept("./f-model.vue?vue&type=template&id=59382bc5&lang=pug&", function () {
      api.rerender('59382bc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-model.vue"
export default component.exports